export const init = () => {
    const hamburger = document.querySelector('.header-hamburger');
    const mobileMenu = document.querySelector('.mobile-menu');
    const overlay = document.querySelector('.mobile-menu-overlay');
    const body = document.body;

    if (!hamburger || !mobileMenu || !overlay) return;

    const closeButton = mobileMenu.querySelector('.button-close');
    let lastActiveElement = null;

    const getFocusableElements = () => {
        const links = Array.from(mobileMenu.querySelectorAll('a'));
        return closeButton ? [closeButton, ...links] : [hamburger, ...links];
    };

    const handleTab = (e) => {
        if (e.key !== 'Tab') return;

        const focusables = getFocusableElements();
        if (focusables.length === 0) return;

        const firstEl = focusables[0];
        const lastEl = focusables[focusables.length - 1];

        if (e.shiftKey) {
            // Shift + Tab
            if (document.activeElement === firstEl) {
                lastEl.focus();
                e.preventDefault();
            }
        } else {
            // Tab
            if (document.activeElement === lastEl) {
                firstEl.focus();
                e.preventDefault();
            }
        }
    };

    const closeMenu = () => {
        hamburger.classList.remove('active');
        mobileMenu.classList.remove('active');
        overlay.classList.remove('active');
        body.classList.remove('menu-open');
        hamburger.setAttribute('aria-expanded', 'false');
        document.removeEventListener('keydown', handleEsc);
        document.removeEventListener('keydown', handleTab);
        
        // Restore focus
        if (lastActiveElement) {
            lastActiveElement.focus();
        }
    };

    const handleEsc = (e) => {
        if (e.key === 'Escape') {
            closeMenu();
        }
    };

    const toggleMenu = () => {
        const isActive = mobileMenu.classList.toggle('active');
        hamburger.classList.toggle('active');
        overlay.classList.toggle('active');
        body.classList.toggle('menu-open');
        
        hamburger.setAttribute('aria-expanded', isActive);

        if (isActive) {
            lastActiveElement = document.activeElement;
            document.addEventListener('keydown', handleEsc);
            document.addEventListener('keydown', handleTab);
            
            // Shift focus to first interactive element inside mobile menu drawer
            const firstFocusable = closeButton || mobileMenu.querySelector('a');
            if (firstFocusable) {
                // Short timeout to allow menu transition animations to finish
                setTimeout(() => firstFocusable.focus(), 100);
            }
        } else {
            document.removeEventListener('keydown', handleEsc);
            document.removeEventListener('keydown', handleTab);
            if (lastActiveElement) {
                lastActiveElement.focus();
            }
        }
    };

    hamburger.addEventListener('click', (e) => {
        e.preventDefault();
        toggleMenu();
    });

    if (closeButton) {
        closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            closeMenu();
        });
    }

    overlay.addEventListener('click', closeMenu);

    // Close on menu link click (important for SPAs like Barba)
    const menuLinks = mobileMenu.querySelectorAll('a');
    menuLinks.forEach(link => {
        link.addEventListener('click', closeMenu);
    });

    // Ensure menu is closed if Barba transition starts (just in case)
    if (window.barba) {
        barba.hooks.before(() => {
            closeMenu();
        });
    }
};
